import { createContext, useContext, type ComponentType } from 'react';

interface Router {
  NavLink: ComponentType<any>;
  useLocation: () => { pathname: string };
}

const RouterContext = createContext<Router | null>(null);

export function RouterProvider({ NavLink, useLocation, children }) {
  return (
    <RouterContext.Provider value={{ NavLink, useLocation }}>
      {children}
    </RouterContext.Provider>
  );
}

export function useRouterContext() {
  const ctx = useContext(RouterContext);
  if (!ctx) {
    throw new Error(
      'KoobSidebar: router prop is required. Pass { NavLink, useLocation } from react-router-dom.',
    );
  }
  return ctx;
}
